import { render, staticRenderFns } from "./CrewMember.vue?vue&type=template&id=731e3bf6&scoped=true&lang=pug&"
import script from "./CrewMember.vue?vue&type=script&lang=js&"
export * from "./CrewMember.vue?vue&type=script&lang=js&"
import style0 from "./CrewMember.vue?vue&type=style&index=0&id=731e3bf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731e3bf6",
  null
  
)

export default component.exports